
import { Input } from "../Input/Input";
import { FaTimes } from "react-icons/fa";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";

type UpdateAvailabilityModalProps = {
  isOpen: boolean;
  orderNumber?: number | null;
  leadTimeDays: number | "";
  onChangeLeadTime: (value: number | "") => void;
  onClose: () => void;
  onSave: () => void;
  isSaving?: boolean;
};

const UpdateAvailabilityModal = ({
  isOpen,
  orderNumber,
  leadTimeDays,
  onChangeLeadTime,
  onClose,
  onSave,
  isSaving = false
}: UpdateAvailabilityModalProps) => {

  if (!isOpen) {
    return null;
  }

  const isSaveDisabled = isSaving || leadTimeDays === "";

  return (
    <Modal overlayClassName="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-md shadow-xl px-5 md:px-6 py-8 md:py-9 relative w-full max-w-md">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-primary-600 hover:text-primary-700 text-2xl font-bold"
          type="button"
        >
          <FaTimes />
        </button>

        {orderNumber && (
          <h3 className="text-lg font-bold text-primary-600 mb-4">{"Pedido"} #{orderNumber}</h3>
        )}
        <h4 className="text-md font-semibold mb-4">{"Atualizar disponibilidade"}</h4>

        <div className="flex flex-col gap-4">
          <Input
            label={"Prazo estimado (dias)"}
            type="number"
            min={0}
            value={leadTimeDays}
            onChange={(e) => onChangeLeadTime(e.target.value === "" ? "" : Number(e.target.value))}
            placeholder={"Ex: 5"}
            required
          />
        </div>

        <div className="w-full flex items-center justify-center gap-2 pt-6">
          <Button variant="secondary"
            className="w-full py-2"
            onClick={onClose}
            type="button"
            disabled={isSaving}
          >
            {"CANCELAR"}
          </Button>
          <Button isLoading={isSaving}
            className="w-full py-2"
            onClick={onSave}
            type="button"
            disabled={isSaveDisabled}
          >
            {"SALVAR"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateAvailabilityModal;
